import script from "./SandBoxLabourForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SandBoxLabourForm.vue?vue&type=script&setup=true&lang=js"

import "./SandBoxLabourForm.vue?vue&type=style&index=0&id=417d2b70&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-417d2b70"]])

export default __exports__